import * as React from 'react';
import { useSelector } from 'react-redux';
import { EFairPlayErrorCode, EFairPlayStatus } from '../../../../../../redux/reducers';
import { OnlyForFairPlayersInitialContainer } from '../OnlyForFairPlayersInitial';
import { OnlyForFairPlayersLoader } from '../OnlyForFairPlayersLoader';
import { OnlyForFairPlayersSuccess } from '../OnlyForFairPlayersSuccess';
import { OnlyForFairPlayersFatalErrorContainer } from '../OnlyForFairPlayersFatalError';
import { selectFairPlayErrorCode, selectFairPlayStatus } from '../../../../../../selectors/fairPlay';
import { OnlyForFairPlayersDeclineError } from '../OnlyForFairPlayersDeclineError';

export const OnlyForFairPlayersContainer = () => {
  const status = useSelector(selectFairPlayStatus);
  const errorCode = useSelector(selectFairPlayErrorCode);

  switch (status) {
    case EFairPlayStatus.initial:
      return <OnlyForFairPlayersInitialContainer />;

    case EFairPlayStatus.pending:
      return <OnlyForFairPlayersLoader />;

    case EFairPlayStatus.success:
      return <OnlyForFairPlayersSuccess />;

    case EFairPlayStatus.fail:
      if (errorCode && errorCode === EFairPlayErrorCode.requestDeclined) {
        return <OnlyForFairPlayersDeclineError />;
      }

      return <OnlyForFairPlayersFatalErrorContainer />;

    default:
      return null;
  }
};
